module.exports = __webpack_public_path__ + "img/1121921487.a3623347.png";